"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.distributionProductDeleteApi = distributionProductDeleteApi;
exports.distributionProductListApi = distributionProductListApi;
exports.distributionProductSaveApi = distributionProductSaveApi;
exports.distributionProductSkusApi = distributionProductSkusApi;
exports.distributionProductStatusApi = distributionProductStatusApi;
exports.distributionProductToggleApi = distributionProductToggleApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 商户端淘客商品。
 * merId 一律由后端按登录态回填，前端不传也不该传 —— 传了也会被忽略。
 */

/** 本店淘客商品列表。 */
function distributionProductListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/distribution/product/list',
    method: 'get',
    params: params
  });
}

/** 按商品ID批量查本店淘客配置，用于商品库列表标注淘客状态。 */
function distributionProductStatusApi(productIds) {
  return (0, _request.default)({
    url: '/admin/merchant/distribution/product/status',
    method: 'post',
    data: productIds
  });
}

/** 新增或编辑本店淘客商品配置。 */
function distributionProductSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/distribution/product/save',
    method: 'post',
    data: data
  });
}

/** 开关本店淘客商品。 */
function distributionProductToggleApi(id, open) {
  return (0, _request.default)({
    url: "/admin/merchant/distribution/product/toggle/".concat(id),
    method: 'post',
    params: {
      open: open
    }
  });
}

/** 某商品的规格列表，供加入门店专区时勾选参加规格。后端按登录态校验商品归属。 */
function distributionProductSkusApi(productId) {
  return (0, _request.default)({
    url: '/admin/merchant/distribution/product/skus',
    method: 'get',
    params: {
      productId: productId
    }
  });
}

/** 删除本店淘客商品配置。 */
function distributionProductDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/distribution/product/".concat(id),
    method: 'delete'
  });
}